import angular from 'angular';
import adminpulse from '@/shared/utils/adminpulse';
import AuthService from '@/shared/services/AuthService';
import moment from 'moment';

const taskPlanningSection = 'eb7ea273-82f2-4d9a-9bff-abf3b8ae25ac';

const mapBudget = function(data) {
  if (!data) {
    return null;
  }
  data.periodFrom = adminpulse.toDateOnly(data.periodFrom);
  data.periodUntil = adminpulse.toDateOnly(data.periodUntil);
  return data;
};

angular.module('cxRelations').directive('cxInvoiceStream', function() {
  return {
    restrict: 'E',
    template: require('./invoiceStream.html'),
    scope: {
      list: '=data',
      field: '=field',
      relation: '=',
    },
    controller: [
      '$scope',
      '$rootScope',
      'resourceFactorySvc',
      'flySvc',
      'ModalService',
      'dialogsSvc',
      'invoiceDialogsSvc',
      '$http',
      'appUrls',
      'checkFeature',
      'relBudgetSvc',
      'checkInvoiceTeamAccess',
      'userData',
      'relBindSvc',
      '$filter',
      function(
        $scope,
        $rootScope,
        resourceFactorySvc,
        flySvc,
        ModalService,
        dialogsSvc,
        invoiceDialogsSvc,
        $http,
        appUrls,
        checkFeature,
        relBudgetSvc,
        checkInvoiceTeamAccess,
        userData,
        relBindSvc,
        $filter,
      ) {
        var notifyInvoiceStreamsChanged = function() {
          $rootScope.$broadcast('invoiceStreamsChanged', { relationId: $scope.relation.id });
        };
        var invoiceStreamName = $filter('invoiceStreamName');
        var showError = function(error) {
          flySvc.error(error);
          return '';
        };
        var resource = resourceFactorySvc.get('invoiceStream');
        $scope.invTypeCnt = [0, 0, 0];

        $scope.defaultStream = null;
        $scope.budgets = {}; //store per invoicestreamId
        $scope.showInvoicingViaColumn = false;

        $scope.hasInactive = false;
        $scope.showInactive = !userData.get('HideInactiveInvoiceStreams', false);

        var recalcInvTypeCnt = function() {
          $scope.invTypeCnt[0] = $scope.invTypeCnt[1] = $scope.invTypeCnt[2] = 0;
          $scope.showInvoicingViaColumn = false;
          if (!$scope.list) return;
          for (var i = 0; i < $scope.list.length; i++)
            if ($scope.list[i].schedule && $scope.list[i].schedule.id)
              $scope.invTypeCnt[$scope.list[i].schedule.invoicingType]++;

          $scope.showInvoicingViaColumn = $scope.list.some(
            x => !x.schedule || !!x.invoicingViaRelation,
          );
        };

        var reloadInvoiceStreams = function() {
          resourceFactorySvc.get('invoiceStream').invoiceStreams(
            {
              id: $scope.relation.id,
            },
            function(data) {
              if (data) {
                $scope.list = data;
                $scope.defaultStream = data.find(x => !x.assignmentId);
                loadBudgets();
                reloadErrors();
              }
            },
          );
        };
        var setDefaultStream = function() {
          $scope.defaultStream = $scope.list ? $scope.list.find(x => !x.assignmentId) : null;
          $scope.hasInactive = $scope.list
            ? $scope.list.some(
                x =>
                  !!x.assignmentId &&
                  !!x.endDate &&
                  moment.utc(x.endDate).isBefore(moment.utc(), 'day'),
              )
            : false;
        };

        var refreshMergeWithName = function(stream) {
          if (!stream) return;
          stream.mergeError = null;
          if (!stream.mergeWithInvoiceStreamId || !$scope.list) {
            stream.mergeWithName = null;
            return;
          }
          var target = $scope.list.find(x => x.id === stream.mergeWithInvoiceStreamId);
          if (target) {
            stream.mergeWithName = invoiceStreamName(target);

            if (
              (stream.companyId ?? $scope.relation.companyId) !==
              (target.companyId ?? $scope.relation.companyId)
            ) {
              stream.mergeError = $filter('translate')('CanNotMergeCompanyDoesNotMatch');
            }
          } else {
            stream.mergeWithName = '/';
          }
        };

        var refreshAllMergeWithNames = function() {
          if (!$scope.list) return;
          $scope.list.forEach(refreshMergeWithName);
        };
        var reloadErrors = () => {
          if (!$scope.list) return;
          $http
            .get(`${appUrls.api}/api/InvoiceStream/Errors/${$scope.relation.id}`)
            .then(({ data }) => {
              $scope.list.forEach(stream => {
                let errors = data ? data[stream.id] : null;
                if (typeof errors === 'string') {
                  errors = JSON.parse(errors);
                }
                if (!!errors) {
                  stream.errorMessages = errors
                    .map(({ code, type, parameters }) =>
                      flySvc.getErrorMsg(code, parameters, null, type),
                    )
                    .join('\r\n');
                  stream.hasError = errors.length > 0;
                } else {
                  stream.errorMessages = null;
                  stream.hasError = false;
                }
              });

              console.log(data);
              stream.errorMessage = data;
              return data;
            }, showError);
        };

        $scope.$watchCollection('list', function() {
          recalcInvTypeCnt();
          setDefaultStream();
          loadBudgets();
          reloadErrors();
          refreshAllMergeWithNames();
        });

        recalcInvTypeCnt();
        setDefaultStream();
        refreshAllMergeWithNames();

        var reloadBudget = function(invoiceStreamId) {
          if (!invoiceStreamId) return;
          if (
            !AuthService.hasPermission({
              functionality: 'BudgetHours',
              privilege: 'Read',
            }) &&
            !AuthService.hasPermission({
              functionality: 'BudgetAmounts',
              privilege: 'Read',
            })
          )
            return;
          return $http
            .get(`${appUrls.api}/api/Budget/Current/${invoiceStreamId}`)
            .then(({ data }) => {
              const budget = mapBudget(data);
              $scope.budgets[invoiceStreamId] = budget;
              return budget;
            }, showError);
        };
        var loadBudgets = function(reload = false) {
          if (!$scope.list) return;
          const streams = reload
            ? $scope.list
            : $scope.list.filter(x => typeof $scope.budgets[x.id] === 'undefined');

          if (streams.length === 0) return;
          streams.forEach(stream => {
            reloadBudget(stream.id);
          });
        };

        $scope.save = function(stream, field, data) {
          //Validation error
          if (typeof data === 'undefined') return '';
          if (field === 'startDate' && !data) return '';

          if (angular.equals(stream[field], data)) return false;
          var model = angular.copy(stream);

          model.deleteExistingLines = true;

          var updateFunction = function(updatedModel) {
            return resource.update(updatedModel).$promise.then(function(response) {
              if (response) angular.extend(stream, response);
              flySvc.success('msgConfirmChange');
              if (field === 'schedule') recalcInvTypeCnt();
              if (field === 'companyId') {
                reloadBudget(stream.id);
                relBudgetSvc.reload($scope.relation.id);
                refreshAllMergeWithNames();
                reloadErrors();
              }
              return false;
            }, showError);
          };

          var showChangeScheduleDialog = function(callback, model) {
            return dialogsSvc
              .showYesNoCancel(
                'msgChangeInvoiceStreamScheduleTitle',
                'msgInvoiceStreamChangeExistingSchedules',
              )
              .then(
                function(result) {
                  if (result == null) return false;
                  model.deleteExistingLines = result;

                  return callback(model);
                },
                function() {
                  return false;
                },
              );
          };

          var fieldHadValue = model[field];

          model[field] = data;

          if (field === 'schedule' && fieldHadValue) {
            //If the schedule was not empty before and has now changed, show dialog asking if existing lines should be deleted
            return showChangeScheduleDialog(updateFunction, model);
          } else {
            return updateFunction(model);
          }
        };

        $scope.filterMergeable = function(currentStream) {
          return function(other) {
            if (other.id === currentStream.id) return false;
            if (other.mergeWithInvoiceStreamId) return false;
            return true;
          };
        };

        $scope.updateMergeWith = function(stream, mergeWithId) {
          if (angular.equals(stream.mergeWithInvoiceStreamId, mergeWithId || null)) return false;
          return $http
            .put(`${appUrls.api}/api/invoiceStream/MergeWith`, {
              id: stream.id,
              mergeWithId: mergeWithId || null,
            })
            .then(
              ({ data }) => {
                if (data) angular.extend(stream, data);
                else stream.mergeWithInvoiceStreamId = mergeWithId || null;
                refreshMergeWithName(stream);
                reloadErrors();
                flySvc.success('msgConfirmChange');
                return false;
              },
              error => {
                flySvc.error(error);
                return false;
              },
            );
        };

        $scope.showPlannedSchedules = function(stream) {
          ModalService.showModal({
            template: require('../dialogs/invoiceStreamScheduleDialog.html'),
            controller: 'InvoiceStreamScheduleDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              stream: stream,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
            modal.close.then(function(result) {
              if (result) {
                reloadInvoiceStreams();
              }
            });
          });
        };

        $scope.showAuthResources = function(stream) {
          ModalService.showModal({
            template: require('../dialogs/authResourcesDialog.html'),
            controller: 'AuthResourcesDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              stream: stream,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.close.then(function(result) {
              if (typeof result === 'undefined' || result === null) return false;

              return flySvc.success('msgConfirmChange');
            });
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
          });
        };

        $scope.showInvoiceStreamSettings = function(stream, forInvoicingVia = false) {
          ModalService.showModal({
            template: require('../dialogs/invoiceStreamSettingsDialog.html'),
            controller: 'InvoiceStreamSettingsDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              invoicestream: stream,
              relation: $scope.relation,
              forInvoicingVia,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
            modal.close.then(function(result) {
              if (result) {
                angular.extend(stream, result);
                recalcInvTypeCnt();
              }
            });
          });
        };
        $scope.showBillingSettings = function(stream) {
          ModalService.showModal({
            template: require('../dialogs/billingSettingsDialog.html'),
            controller: 'BillingSettingsDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              invoicestream: stream,
              relation: $scope.relation,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
            modal.close.then(function(result) {
              if (result) {
                angular.extend(stream, result);
                recalcInvTypeCnt();
              }
            });
          });
        };

        $scope.addAssignment = function() {
          ModalService.showModal({
            template: require('../dialogs/addAssignmentDialog.html'),
            controller: 'AddAssignmentDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              relation: $scope.relation,
              invoiceStreams: $scope.list || [],
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
            modal.close.then(function(result) {
              if (result) {
                const { invoiceStream, hasTaskSchedules } = result;

                $scope.list.push(invoiceStream);
                notifyInvoiceStreamsChanged();
                recalcInvTypeCnt();
                loadBudgets();
                reloadErrors();

                if (
                  hasTaskSchedules &&
                  (!$scope.relation.sectionStatus ||
                    typeof $scope.relation.sectionStatus[taskPlanningSection] !== 'undefined')
                ) {
                  relBindSvc.refreshSection($scope.relation.id, taskPlanningSection);
                }
              }
            });
          });
        };

        $scope.deleteAssignment = function(stream) {
          if (!stream || !stream.id || !stream.assignmentId) return;
          ModalService.showModal({
            template: require('../dialogs/deleteAssignmentDialog.html'),
            controller: 'DeleteAssignmentDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              invoiceStreamId: stream.id,
              relationId: $scope.relation.id,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
            modal.close.then(function(result) {
              if (result) {
                if ($scope.budgets[stream.id]) relBudgetSvc.reload($scope.relation.id);
                delete $scope.budgets[stream.id];
                var idx = $scope.list.indexOf(stream);
                if (idx >= 0) {
                  $scope.list.splice(idx, 1);
                }
                notifyInvoiceStreamsChanged();
              }
            });
          });
        };

        $scope.editAssignment = function(stream) {
          if (!stream || !stream.id || !stream.assignmentId) return;
          ModalService.showModal({
            template: require('../dialogs/editAssignmentDialog.html'),
            controller: 'EditAssignmentDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              invoiceStream: { ...stream },
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
            modal.close.then(function(result) {
              if (result) {
                angular.extend(stream, result);
                notifyInvoiceStreamsChanged();
                recalcInvTypeCnt();
              }
            });
          });
        };

        $scope.showInvoicingHistory = function(stream) {
          invoiceDialogsSvc.showInvoicingHistory(stream.id, null, $scope.relation.id);
        };

        $scope.deleteActiveSchedule = function(stream) {
          return $http
            .get(`${appUrls.api}/api/invoiceStream/InvoiceStreamHasDraftInvoices/${stream.id}`)
            .then(
              ({ data }) => {
                if (data) {
                  return dialogsSvc
                    .showYesNo(
                      'msgConfirmDeleteTitle',
                      'msgConfirmDeleteActiveInvoiceScheduleWithDraftInvoices',
                    )
                    .then(function() {
                      return doDeleteActiveSchedule(stream);
                    });
                } else {
                  return dialogsSvc
                    .showYesNo('msgConfirmDeleteTitle', 'msgConfirmDeleteActiveInvoiceSchedule')
                    .then(function() {
                      return doDeleteActiveSchedule(stream);
                    });
                }
              },
              function(error) {
                flySvc.error(error.data.code, error.data.parameters);
                return '';
              },
            );
        };

        var doDeleteActiveSchedule = stream => {
          stream.deletingActiveSchedule = true;
          return resourceFactorySvc
            .get('invoiceStream')
            .clearActiveSchedule({
              id: stream.id,
            })
            .$promise.then(
              function(response) {
                stream.deletingActiveSchedule = false;
                if (response) {
                  if (response) angular.extend(stream, response);
                  flySvc.success('msgConfirmChange');
                  recalcInvTypeCnt();
                  return false;
                }
                return false;
              },
              function(error) {
                stream.deletingActiveSchedule = false;
                showError(error);
              },
            );
        };
        $scope.saveBudget = function(invoiceStreamId, field, data) {
          //Validation error
          if (typeof data === 'undefined') return '';
          const budget = $scope.budgets[invoiceStreamId] || { invoiceStreamId };
          if (angular.equals(budget[field], data)) return false;
          var model = angular.copy(budget);
          model[field] = data;
          if (model.budgetFrom instanceof Date) model.budgetFrom = model.budgetFrom.ISO();
          if (model.budgetUntil instanceof Date) model.budgetUntil = model.budgetUntil.ISO();
          return $http.put(`${appUrls.api}/api/budget/`, model).then(({ data }) => {
            const newBudget = mapBudget(data);
            $scope.budgets[invoiceStreamId] = newBudget;
            relBudgetSvc.reload($scope.relation.id);
            return false;
          }, showError);
        };

        $scope.showBudgetDialog = function(invoiceStream) {
          ModalService.showModal({
            template: require('../dialogs/invoiceStreamBudgetDialog.html'),
            controller: 'InvoiceStreamBudgetDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              stream: invoiceStream,
              readOnly: !$scope.relation.hasInvoiceTeamAccess,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
            modal.close.then(function(result) {
              if (result) {
                reloadBudget(invoiceStream.id);
                relBudgetSvc.reload($scope.relation.id);
              }
            });
          });
        };

        $scope.showInactiveChanged = function() {
          userData.set('HideInactiveInvoiceStreams', !$scope.showInactive);
        };
        $scope.filterInactive = function(stream) {
          if (!$scope.hasInactive) return true;
          if (!!$scope.showInactive) return true;
          if (!stream.assignmentId) return true;
          if (!stream.endDate) return true;
          return moment.utc(stream.endDate).isSameOrAfter(moment.utc(), 'day');
        };
      },
    ],
  };
});
